export default "__VITE_ASSET__CjPZfV0i__"